import { render } from "./RegisterSuccess.vue?vue&type=template&id=3c7ac8a0"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"

import "./RegisterSuccess.vue?vue&type=style&index=0&id=3c7ac8a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__